import React, { useEffect, useState } from "react";
import "./sendNotification.scss";

import HeaderBar from "../../components/headerBar/HeaderBar";
import VoidSpace from "../../components/voidSpace/VoidSpace";

import { Button, Dropdown, Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { setGlobalState } from "../../utils/state";
import { gestioneSnackbar } from "../../utils/common";
import { isEmpty } from "../../utils/validation";
import { t } from "i18next";
import {
  getEventsOfAssociationWS,
  getVolunteerOfAssociationWS,
  getVolunteerSubscribedEventWS,
  postNotificationToGroupWS,
} from "./api/sendNotificationApi";

const SendNotification = () => {
  const { id_association } = useParams();

  const [events, setEvents] = useState([]);
  const [volunteers, setVolunteers] = useState([]);
  const [associationVolunteers, setAssociationVolunteers] = useState([]);
  const [title, setTitle] = useState([]);
  const [body, setBody] = useState([]);

  const [selectedEvent, setSelectedEvent] = useState("");
  const [selectedVolunteers, setSelectedVolunteers] = useState([]);

  useEffect(() => {
    setGlobalState("selectedIdBottomBar", 2);

    getEventsOfAssociationWS({ id_association })
      .then((res) => setEvents(res.events))
      .catch((err) => console.error(err));

    getVolunteerOfAssociationWS({ id_association })
      .then((res) => {
        setVolunteers(res);
        setAssociationVolunteers(res);
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    if (selectedEvent)
      getVolunteerSubscribedEventWS({ id_event: selectedEvent })
        .then((res) => setVolunteers(res))
        .catch((err) => {
          setVolunteers([]);
          console.error(err);
        });
    else setVolunteers(associationVolunteers);
  }, [selectedEvent]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isEmpty(selectedVolunteers)) {
      gestioneSnackbar(true, t("send_notification.void_volunteer"), "error");
      return;
    }
    if (isEmpty(title)) {
      gestioneSnackbar(true, t("send_notification.void_title"), "error");
      return;
    }
    if (isEmpty(title)) {
      gestioneSnackbar(true, t("send_notification.void_body"), "error");
      return;
    }

    postNotificationToGroupWS({
      title,
      body,
      user: selectedVolunteers,
      id_event: selectedEvent,
      id_association,
    })
      .then((res) => {
        gestioneSnackbar(true, res, "success");
        setTitle("");
        setBody("");
        setSelectedVolunteers([]);
        setSelectedEvent("");
      })
      .catch((err) => gestioneSnackbar(true, err, "error"));
  };

  const handleCheckboxChange = (optionId) => {
    setSelectedVolunteers((prev) =>
      prev.includes(optionId)
        ? prev.filter((id) => id !== optionId)
        : [...prev, optionId]
    );
  };

  return (
    <>
      <HeaderBar
        title={t("send_notification.title")}
        back={true}
        path={"/dashboard/" + id_association}
      />
      <Form onSubmit={handleSubmit}>
        <div className="container-responsive">
          <div className="send-notification-container">
            <div className="input-container">
              <Form.Select onChange={(e) => setSelectedEvent(e.target.value)}>
                <option value="">{t("send_notification.select_event")}</option>
                {!isEmpty(events)
                  ? events.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    ))
                  : null}
              </Form.Select>
            </div>
            <div className="input-container">
              <Dropdown>
                <Dropdown.Toggle
                  variant="light"
                  id="dropdown-basic"
                  className="dropdown-toggle"
                >
                  {t("send_notification.select_users")}
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdown-menu">
                  {volunteers.map((item, index) => (
                    <Form.Check
                      className="dropdown-item"
                      key={index}
                      type="checkbox"
                      id={`checkbox-${item.id}`}
                      label={item.name + " " + item.surname}
                      checked={selectedVolunteers.includes(item.email)}
                      onChange={() => handleCheckboxChange(item.email)}
                    />
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="input-container">
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {t("send_notification.title_notification")}
                </Form.Label>
                <Form.Control
                  type="text"
                  maxLength={50}
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </Form.Group>
            </div>
            <div className="input-container">
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>
                  {t("send_notification.body_notification")}
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={5}
                  maxLength={255}
                  value={body}
                  onChange={(e) => setBody(e.target.value)}
                />
              </Form.Group>
            </div>
            <div className="button-container">
              <Button variant="info" type="submit">
                {t("common.send")}
              </Button>
            </div>
          </div>
        </div>
      </Form>
      <VoidSpace height={95} />
    </>
  );
};

export default SendNotification;
